module.exports = __webpack_public_path__ + "static/valori_3_small-2d36b2b54c77c2a3e787da537a84b7fd.jpg";